let brick;
function show(options) {
  if (brick) {
    brick.resolve(options);
  } else {
    alert(options.message);
  }
}
export function loadNotificationService(tagName, loader) {
  loader([tagName]).then(() => {
    brick = document.createElement(tagName);
  }, error => {
    // eslint-disable-next-line no-console
    console.error("Load notification service failed:", error);
  });
}
export const Notification = Object.freeze({
  show
});
//# sourceMappingURL=Notification.js.map